import script from "./ClearmentLsk.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearmentLsk.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__